import { Module } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import MyAccountState from '../types/MyAccountState'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'
import { state } from './state'

export const module: Module<MyAccountState, RootState> = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state
}
